/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { ActionIcon, TextInput } from '@mantine/core'

export type SearchFormProps = {
  initialValue?: string
  onSubmit (value?: string): void
  submitting: boolean
}

function SearchForm (props: SearchFormProps) {
  const {
    initialValue,
    onSubmit,
    submitting,
    ...others
  } = props

  const intl = useIntl()
  const [previousValue, setPreviousValue] = useState(initialValue)
  const [value, setValue] = useState(initialValue)
  const modified = value !== previousValue

  const submit = useCallback((val?: string) => {
    setPreviousValue(val)
    setValue(val)
    onSubmit(val)
  }, [onSubmit])

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value === '' ? undefined : event.target.value)
  }, [])

  const handleClear = useCallback(() => {
    submit(undefined)
  }, [submit])

  const handleSubmit = useCallback((event: React.FormEvent) => {
    event.preventDefault()
    event.stopPropagation()
    submit(value)
  }, [submit, value])

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <form
      {...others}
      method="post"
      onSubmit={handleSubmit}
    >
      <TextInput
        name="search"
        onChange={handleChange}
        placeholder={intl.formatMessage({
          id: 'search',
          defaultMessage: 'Rechercher'
        })}
        value={value == null ? '' : value}
        leftSection={value != null && value.length > 0
          ? <ActionIcon
            color="gray"
            onClick={handleClear}
            variant="subtle"
          >
            <FontAwesomeIcon
              fixedWidth
              icon={faTimes}
            />
          </ActionIcon>
          : null}
        rightSection={<ActionIcon
          color={modified ? undefined : 'gray'}
          loading={submitting}
          type="submit"
          variant="subtle"
        >
          <FontAwesomeIcon
            fixedWidth
            icon={faSearch}
          />
        </ActionIcon>}
      />
    </form>
  )
}

export default SearchForm
